import { getDoc, getDocs, serverTimestamp } from 'firebase/firestore';
import { useContext } from 'react';
import { useHistory } from 'react-router-dom';

import { Context } from '../../../index';

const useCreatePrivateChat = () => {
  const { firestore } = useContext(Context);
  const history = useHistory();

  const creatPrivateChat = async (userId, otherUserId) => {
    const resultSnapshot = await getDocs(
      firestore.collection('chat_rooms').where('user_ids', 'array-contains', userId),
    );
    const foundChat = resultSnapshot.docs
      .map((item) => ({
        data: item.data(),
        id: item.id,
      }))
      .find((item) => item.data.user_ids.includes(otherUserId) && item.data.room_type === 0);
    if (foundChat) {
      history.push(`/rooms/${foundChat.id}`);
    } else {
      const last_msg_epoch = serverTimestamp();
      const otherUserSnapshot = await getDoc(firestore.collection('users').doc(otherUserId));
      const otherUser = otherUserSnapshot.data();
      const userName = `${otherUser.last_name ?? ''} ${otherUser.first_name ?? ''}`;
      const newChat = await firestore.collection('chat_rooms').add({
        last_msg: '',
        last_msg_epoch,
        last_msg_sender: '',
        last_msg_type: 0,
        room_avatar: '',
        room_name: userName,
        room_type: 0,
        user_ids: [otherUserId, userId],
      });
      history.push(`/rooms/${newChat.id}`);
    }
  };

  return {
    creatPrivateChat,
  };
};

export default useCreatePrivateChat;
